const PERMISSION_KEY= "core:securities_account_form";
const PAGE_URL = {
    SECURITIES_ACCOUNT_FORM_PAGE: "/admin/core/securities-account-form"
}

export {PERMISSION_KEY, PAGE_URL}

